export const NEW_REVIEW_AUTO_OPEN_FLAG_DASH = 'new-review';

export const NEW_REVIEW_AUTO_OPEN_FLAG_CAMEL = 'newReview';
